<div *ngIf="open" class="fixed inset-0 z-[60] flex items-end sm:items-center justify-center bg-gray-900/60 backdrop-blur-sm sm:p-4">
  <div class="bg-white rounded-t-2xl sm:rounded-2xl shadow-2xl w-full max-w-2xl max-h-[92dvh] sm:max-h-[90vh] flex flex-col">

    <div class="sm:hidden mx-auto mt-3 h-1 w-10 rounded-full bg-gray-300 flex-shrink-0"></div>
    <div class="flex items-center justify-between px-4 sm:px-6 py-4 border-b border-gray-200">
      <div>
        <h2 class="text-lg font-semibold text-gray-900">{{ title }}</h2>
        <p class="text-xs text-gray-500">{{ selectedBuName }}</p>
      </div>
      <button (click)="close()" [disabled]="isSubmitting"
              class="text-gray-400 hover:text-gray-600 disabled:opacity-50">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="flex-1 overflow-y-auto overscroll-contain p-4 sm:p-6 space-y-4">

      <div *ngIf="errorMessage" class="bg-red-50 border border-red-200 text-red-700 px-3 py-2 rounded-lg text-sm">
        {{ errorMessage }}
      </div>

      <!-- Member picker -->
      <div>
        <label class="block text-xs font-medium text-gray-700 mb-1">Member <span class="text-red-500">*</span></label>
        <div class="relative">
          <input type="text" [(ngModel)]="memberSearch" [ngModelOptions]="{standalone: true}"
                 (ngModelChange)="onMemberSearchInput()"
                 [disabled]="isEditMode || lockMember"
                 placeholder="Search by name, NIC, or phone…"
                 class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"/>
          <button *ngIf="memberSearch && !isEditMode && !lockMember" type="button" (click)="clearMember()"
                  class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>

          <div *ngIf="memberResults.length > 0" class="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-y-auto">
            <button *ngFor="let m of memberResults" type="button" (click)="selectMember(m)"
                    class="w-full text-left px-3 py-2 hover:bg-blue-50 border-b border-gray-100 last:border-0">
              <div class="text-sm font-medium text-gray-900">{{ m.fullName }}</div>
              <div class="text-xs text-gray-500">{{ m.nic }} · {{ m.phone }}<span *ngIf="m.monthlyFee != null"> · Rs. {{ m.monthlyFee }}</span></div>
            </button>
          </div>
        </div>
        <p *ngIf="f['memberId'].touched && f['memberId'].invalid" class="text-xs text-red-600 mt-1">Member is required.</p>
        <p *ngIf="isEditMode" class="text-xs text-gray-500 mt-1">Member cannot be changed after recording.</p>
        <p *ngIf="!isEditMode && lockMember" class="text-xs text-gray-500 mt-1">Recording for selected member.</p>
      </div>

      <div class="grid grid-cols-2 sm:grid-cols-4 gap-4">
        <div>
          <label class="block text-xs font-medium text-gray-700 mb-1">Month <span class="text-red-500">*</span></label>
          <select formControlName="month" [class.bg-gray-100]="isEditMode" [attr.disabled]="isEditMode ? true : null"
                  class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
            <option *ngFor="let m of months" [ngValue]="m.value">{{ m.name }}</option>
          </select>
        </div>
        <div>
          <label class="block text-xs font-medium text-gray-700 mb-1">Year <span class="text-red-500">*</span></label>
          <select formControlName="year" [class.bg-gray-100]="isEditMode" [attr.disabled]="isEditMode ? true : null"
                  class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
            <option *ngFor="let y of years" [ngValue]="y">{{ y }}</option>
          </select>
        </div>
        <div>
          <label class="block text-xs font-medium text-gray-700 mb-1">Amount (Rs.) <span class="text-red-500">*</span></label>
          <input type="number" step="0.01" min="0.01" formControlName="amount"
                 class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"/>
        </div>
        <div>
          <label class="block text-xs font-medium text-gray-700 mb-1">Method <span class="text-red-500">*</span></label>
          <select formControlName="paymentMethod"
                  class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
            <option value="Cash">Cash</option>
            <option value="Bank">Bank Transfer</option>
            <option value="Online">Online</option>
            <option value="Cheque">Cheque</option>
          </select>
        </div>
      </div>

      <div>
        <label class="block text-xs font-medium text-gray-700 mb-1">Reference</label>
        <input type="text" formControlName="reference" placeholder="Transaction reference or note"
               class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"/>
      </div>

      @if (!isEditMode) {
        <app-custom-fields-input #cf formKey="Payment"
          [businessUnitId]="customFieldsBuId"></app-custom-fields-input>
      }

    </form>

    <div class="flex flex-col-reverse sm:flex-row sm:items-center sm:justify-end gap-2 sm:gap-3 px-4 sm:px-6 py-4 pb-[max(1rem,env(safe-area-inset-bottom))] sm:pb-4 border-t border-gray-200">
      <button type="button" (click)="close()" [disabled]="isSubmitting"
              class="w-full sm:w-auto max-md:tap-target px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-lg disabled:opacity-50">
        Cancel
      </button>
      <button type="button" (click)="onSubmit()" [disabled]="isSubmitting"
              class="w-full sm:w-auto max-md:tap-target inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg shadow-sm disabled:opacity-50">
        <app-spinner *ngIf="isSubmitting" size="xs" colour="white"></app-spinner>
        {{ isSubmitting ? 'Saving…' : (isEditMode ? 'Save Changes' : 'Record Payment') }}
      </button>
    </div>

  </div>
</div>
